var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navHeader'),_c('router-view',{staticStyle:{"min-height":"100vh"}}),_c('Footer'),_c('mobileFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }